import { HttpServiceResponse } from '../../shared'
import { AccountSearchPages } from '../models/account.types'
import { AccountSearchParams, AccountSearchParamsPost } from '../models/search-params.model'
import AbstractAccountProvider from './account-abstract.provider'

export class AccountSearchProvider extends AbstractAccountProvider {
  urlPath = 'acc_account_search_api'

  public search<T>(page: AccountSearchPages, params: Partial<AccountSearchParams>): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      page,
      ...params,
    })

    return this.http.get(`${this.url}?${query}`)
  }

  public searchPost<T>(
    page: AccountSearchPages,
    params: Partial<AccountSearchParamsPost>,
  ): Promise<HttpServiceResponse<T>> {
    const newParams = {
      ...params,
    }
    delete newParams.instanceName
    const query = this.query.stringify({
      page,
      ...newParams,
    })

    const url = `${this.url}?${query}`

    return this.http.post(`${this.url}?${query}`)
  }
}
